import { Chart, Filler, LineElement, PointElement } from "chart.js";
import { Line } from "react-chartjs-2";
Chart.register(LineElement, Filler, PointElement);
type Props = {
  label: any[];
  values: any[];
  borderColor: string;
};
const ChartComponent = ({ label, values, borderColor }: Props) => {
  const set: any = {
    labels: label,
    datasets: [
      {
        data: values,
        fill: false,
        borderColor,
        borderWidth: 1,
      },
    ],
  };
  return (
    <>
      <div className="h-8 w-20">
        <Line
          data={set}
          options={{
            responsive: true,

            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false
           }
            },
           
            maintainAspectRatio: false,
            elements: {
              point: {
                radius: 0,
              },
            },
            scales: {
              x: {
                display: false,
                grid: {
                  display: false,
                },
              },
              y: {
                display: false,
                grid: {
                  display: false,
                },
              },
            },
          }}
        />
      </div>
    </>
  );
};
export default ChartComponent;
